import React, { useContext } from "react"
import { Query } from "react-apollo"
import { Redirect } from "react-router"
import { Link } from "react-router-dom"
import SectorFilter from "../../components/SectorFilter"
import AppContext from "../../shared/AppContext"
import Loading from "../../components/Loading"
import gql from "graphql-tag"
import "./ets.scss"

const GET_ETR_VENDORS_QUERY = gql`
  query {
    etsVendorUniverse {
      id
      surveyDate
      sectorName
      productName
    }
  }
`

function AboutETS(props) {
  if (!props.viewer || !props.viewer.isUserAuthenticated) {
    return <Redirect to={{ pathname: "/login", state: { from: "/ets" } }} />
  }

  const { openInquireModal, serviceType, trackEvent } = useContext(AppContext)

  const renderLiveResultsButton = () => {
    const { roles } = props.viewer
    const hasEtsOrAdminRole = roles.some(
      (role) =>
        role === "ETS" ||
        role === "ETR Master Admin" ||
        role === "ETR Research Admin" ||
        role === "ETR Sales Admin"
    )

    if (!hasEtsOrAdminRole) {
      return (
        <button
          className="btn etr-button-blue-gradient"
          data-cy="cta-button"
          onClick={() => {
            trackEvent("ETS Upgrade Today button clicked")
            openInquireModal(serviceType.UpgradePlan)
          }}
        >
          Upgrade Today
        </button>
      )
    }

    return (
      <Link
        className="btn etr-button-blue-gradient"
        data-cy="cta-button"
        onClick={() => trackEvent("ETS Live Results button clicked")}
        to="/ets/survey-highlights/10kview"
      >
        Live Results
      </Link>
    )
  }

  const etsSurveyText =
    "For each enterprise technology, the IT Decision Maker will provide their organization’s calendar year or 2H spending intentions vs their actual spend in the prior period."

  return (
    <main className="about-ets main-content">
      <h1 className="title-page">Emerging Technology Survey</h1>
      <section className="intro-ets">
        <div>
          <p>
            The Emerging Technology Survey (ETS) is our quarterly survey of
            5,000+ IT decision makers capturing the enterprise's appetite for
            nearly 400+ emerging technology vendors across the global market.
            Coverage includes vendors within <SectorFilter {...props} />
          </p>
          {renderLiveResultsButton()}
          <p>
            ETR derives meaningful insights and predictors of enterprise
            technology performance from the survey data and delivers those
            through proprietary visualizations and models.
          </p>
          <br />
          <p className="hide-mobile">{etsSurveyText}</p>
        </div>
        <div style={{ textAlign: "center" }}>
          <h2 className="title-survey">ETS SURVEY: CONDUCTED QUARTERLY</h2>
          <figure>
            <img
              className="ets-quarters-image"
              alt="ets quarters survey"
              src="/static/images/about-ets-quarterly.png"
            />
          </figure>
          <p style={{ textAlign: "left" }} className="hide-desktop">
            {etsSurveyText}
          </p>
        </div>
      </section>
      <section>
        <div className="about-ets-survey"></div>
      </section>
      <section>
        <h2 className="title-page">How to use this data? ​</h2>
        <div className="ets-how-to-use"></div>
      </section>
    </main>
  )
}

const ETSWithData = (componentProps) => {
  return (
    <Query query={GET_ETR_VENDORS_QUERY}>
      {({ data, loading, error }) => {
        if (loading) {
          return <Loading />
        }
        if (!data || error) {
          return (
            <div
              style={{
                textAlign: "center",
                padding: "2em",
                color: "var(--gray-secondary-500)",
              }}
            >
              <p>Error when fetching data</p>
            </div>
          )
        }

        return <AboutETS {...componentProps} vendors={data.etsVendorUniverse} />
      }}
    </Query>
  )
}

export default ETSWithData
